/**
 *
 * Asynchronously loads the component for ConnectBank
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ConnectBank = lazyLoad(
  () => import('./index'),
  module => module.ConnectBank,
);
